/**
 * Extend Object by Another Object
 *
 * First argument is target object. Properties from second arguments will be included to target object.
 * Same with third parameter.
 *
 * @param {Object}  target  Object to extend
 * @param {Object}  source  Sources of properties to extend
 * @param {Object}  [source2..sourceN]  Same as source
 * @return {Object} Result of merge source object to target object
 */
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source, source2) {
  var args = Array.prototype.slice.call(arguments);
  var obj = args.shift();

  if (typeof obj === 'object') {
    args.forEach(function(ext) {
      // Extend target object only with type of object, other types will be ignored.
      if (typeof ext === 'object') {
        Object.keys(ext).forEach(function(key) {
          obj[key] = ext[key];
        });
      }
    });
  }

  return obj;
};
